var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"item-d prk-fz-12 font-weight-bold",class:_vm.activeColor},[_vm._v("\n  "+_vm._s(_vm.$t('general.teaching_effects'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }